import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { emptyUser, User } from "../../../../interfaces/user";
import { deleteUser, getUserSingle } from "../../../../services/user";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminUserDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminUserDelete(props: AdminUserDeleteProps) {
    const [user, setUser] = useState<User>(emptyUser);

    const handleDelete = () => {
        deleteUser(props.id)
            .then(response => {
                props.onDelete(props.id);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getUserSingle(props.id)
            .then(response => {
                setUser(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-user-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_user") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { user.id == 0 && 
                    <LoadingSpinner />
                }
                { user.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_user_message"
                                values={{
                                    user_name: user.name,
                                    user_email: user.email
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
